<template>
  <div class="app-container">
    <div class="wt-form-tablelist-container integral-points">
      <el-tabs v-model="activeTabName">
        <el-tab-pane label="所有用户总排名" name="first"></el-tab-pane>
        <el-tab-pane label="社区内总排名" name="second"></el-tab-pane>
      </el-tabs>
      <div v-if="activeTabName === 'first'">
        <wt-form-table ref="firstFormRef" key="1" :form.sync="firstForm" @on-button-action="onButtonAction" >
          <wt-form-table-list ref="firstFormTableRef" slot="wtFormTableList" :form.sync="firstForm" @on-button-action="onButtonAction">
            <template slot="totalWeight" slot-scope="data">
              <span>{{ $wtUtil.transWeight(data.row.totalWeight) }}</span>
            </template>
          </wt-form-table-list>
        </wt-form-table>
      </div>
      <div v-if="activeTabName === 'second'">
        <wt-form-table ref="secondFormRef" key="2" :form.sync="secondForm" @on-button-action="onButtonAction" >
          <wt-form-table-list ref="firstFormTableRef" slot="wtFormTableList" :form.sync="secondForm" @on-button-action="onButtonAction">
            <template slot="totalWeight" slot-scope="data">
              <span>{{ $wtUtil.transWeight(data.row.totalWeight) }}</span>
            </template>
          </wt-form-table-list>
        </wt-form-table>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      activeTabName: 'first',
      formInputsData: [
        // { name: '搜索用户', key: 'name', value: '', type: 'text' },
        { name: '社区', key: 'communityId', value: '', type: 'text' },
        { name: '创建时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
      firstForm: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_USERINTEGRALDETAILS',
        formComponent: {
          list: { type: 'default', value: '/modules/userIntegralDetails/userIntegralRanking' }
        },
        formInputsData: [
          { name: '手机号', key: 'keyWord', value: '', type: 'text' },
          { name: '社区', key: 'communityId', value: '', type: 'select', data: [] },
          { name: '创建时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [],
        formTableData: [
          { name: '排名', key: 'rank', type: 'customAll' },
          { name: '昵称', key: 'nickName', type: 'text' },
          { name: '手机号码', key: 'phone', type: 'text' },
          // { name: '省市区', key: 'type', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '投递重量(kg)', key: 'totalWeight', type: 'custom' },
          { name: '创建时间', key: 'createTime', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: false, buttonHidden: true, indexLabel: '排名' }
      },
      secondForm: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_USERINTEGRALDETAILS',
        formComponent: {
          view: { type: 'component', componentName: 'IntegralRankingView', value: '', noRequest: true },
          list: { type: 'default', value: '/modules/userIntegralDetails/communityIntegralRanking' }
        },
        formInputsData: [
          // { name: '搜索用户', key: 'keyWord', value: '', type: 'customAll' },
          { name: '社区', key: 'communityName', value: '', type: 'text' },
          { name: '创建时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [],
        formTableData: [
          { name: '排名', key: 'rank', type: 'text' },
          // { name: '省市区', key: 'type', type: 'text' },
          { name: '社区', key: 'name', type: 'text' },
          { name: '投递重量(kg)', key: 'totalWeight', type: 'custom' },
          { name: '创建时间', key: 'createTime', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: false, indexLabel: '排名' }
      },
      dialogVisible: false,
      integralValidateForm: {
        integral: 0,
        reason: ''
      }
    }
  },
  mounted() {
    this.requestcommunityList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setUserIntegralDetailsDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    },
    toSearch() {
      console.log(this.formInputsData)
      this.setTableForm()
      this.searchTableData()
    },
    toReset() {
      this.formInputsData[0].value = ''
      this.formInputsData[1].value = ''
      this.formInputsData[2].value = []
      this.setTableForm()
      this.searchTableData()
    },
    setTableForm() {
      this.firstForm.formInputsData[0].value = this.formInputsData[0].value
      this.firstForm.formInputsData[1].value = this.formInputsData[1].value
      // this.firstForm.formInputsData[2].value = this.formInputsData[2].value
      this.secondForm.formInputsData[0].value = this.formInputsData[0].value
      this.secondForm.formInputsData[1].value = this.formInputsData[1].value
      // this.secondForm.formInputsData[2].value = this.formInputsData[2].value
    },
    searchTableData() {
      if (this.activeTabName === 'first') {
        this.$refs.firstFormRef.requestFormList()
      }
      if (this.activeTabName === 'second') {
        this.$refs.secondFormRef.requestFormList()
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    requestFormList() {
      console.log(112244)
    },
    requestcommunityList() {
      request({
        url: '/modules/community/communityNoPageList',
        method: 'post'
      }).then(res => {
        if (res.code === '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          this.firstForm.formInputsData[1].data = res.data
        }
      })
    }
  }
}
</script>
<style>
.integral-points {
  padding: 20px;
}
</style>
